(function iife() {
	"use strict";

	angular.
	module("dx.webapp.node").
	component("dxNodeClientSettings", {
		templateUrl: "tmpl/node/node-client-settings.html",
		controller: "DxNodeClientSettingsController",
		controllerAs: "vm",
		bindings: {
			node: "<",
		},
	});
}());
